import * as yup from "yup";
import {
    MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE,
    MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER,
    MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR,
    MEDSTAR_ASSOCIATION_TYPE__STUDENT,
    MEDSTAR_ASSOCIATION_TYPE__VENDOR,
    MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER,
    MEDSTAR_ASSOCIATION_TYPE__UNKNOWN
} from "../../sitel/commons/utilities/medstarAssociationType";

export default function schema(medstarAssociationType) {
    const fnMsg = "You must enter first name",
          lnMsg = "You must enter last name",
        //TOBEDELETED20240306 ssnMsg = "You must enter last 4 digits of your SSN",
        //TOBEDELETED20240306 dobMsg = "DOB must be in format above",
        //TOBEDELETED20240306 phoneMsg = "You must enter a phone number",
          zipMsg = "Zipcode must be exactly 5 digits";

    //basic form
    const schema = {
        firstName: yup.string().required(fnMsg)
            .min(2, fnMsg)
            .max(30, fnMsg),

        lastName: yup.string().required(lnMsg)
            .min(2, lnMsg)
            .max(30, lnMsg),

        ssn4: yup
            .string()
            .required("You must enter last 4 digits of your SSN")
            .length(4, "Must be 4 digits long.")
            .matches(/^\d+$/, 'Last 4 digits must contain only numbers.'),

        //   TOBEDELETED20230510
        // dob: yup.date().nullable().typeError(dobMsg), //.date().required(dobMsg).nullable(),

        phone: yup.string()
            .length(10, 'Phone number must be exactly 10 digits')
            .matches(/^\d+$/, 'Phone number must only contain digits')
            .required('Phone number is required'),

        address1: yup.string().required("You must enter address")
            .min(5)
            .max(100),

        address2: yup.string().max(100),

        city: yup.string().required("You must enter city")
            .min(3)
            .max(100),

        state: yup.string().required("You must select state")
            .length(2, "You must select state"),

        zip: yup.number().typeError(zipMsg)
            .required(zipMsg)
            .positive(zipMsg)
            .integer(zipMsg)

    };

    //by association type specific schema
    switch (medstarAssociationType) {

        case MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE:
            const preEmpsdMsg = "Enter start date of employment";
            schema.startDate = yup.date(preEmpsdMsg)
                .required(preEmpsdMsg);

            const preEmphmnMsg = "Please enter the hiring HR manager's name";
            schema.hiringManagerName = yup.string(preEmphmnMsg)
                .required(preEmphmnMsg);

            const preEmpMeMsg = "Please enter the email of the hiring HR manager";
            schema.hiringManagerEmail = yup.string(preEmpMeMsg)
                .email(preEmpMeMsg)
                .required(preEmpMeMsg);

            const preEmpmeMsg = "Please select the entity you will work at";
            schema.medstarEntity = yup.number(preEmpmeMsg)
                .required(preEmpmeMsg)
                .positive(preEmpmeMsg);

            const preEmpdMsg = "Please enter the name of the department where you will work";
            schema.department = yup.string(preEmpdMsg)
                .required(preEmpdMsg)
                .min(2, preEmpdMsg);

            const preEmplnMSg = "Please enter the name of your MedStar Health leader";
            schema.leaderName = yup.string(preEmplnMSg)
                .required(preEmplnMSg)
                .min(5, preEmplnMSg);

            const preEmpleMsg = "Please enter the email of your MedStar Health leader";
            schema.leaderEmail = yup.string(preEmpleMsg)
                .email(preEmpleMsg)
                .required(preEmpleMsg)
                .min(15, preEmpleMsg);
            break;


        // ---------------------
        case MEDSTAR_ASSOCIATION_TYPE__VENDOR:
        case MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR:
            const vendorVendorMsg = "Please enter the name of your employer";
            schema.vendor = yup.number()
                .typeError(vendorVendorMsg)
                .min(0, vendorVendorMsg);

            const vendormeMsg = "Please select the entity you work at";
            schema.medstarEntity = yup.number(vendormeMsg)
                .required(vendormeMsg)
                .positive(vendormeMsg);

            const vendordMsg = "Please enter the name of the department where you will work";
            schema.department = yup.string(vendordMsg)
                .required(vendordMsg)
                .min(2, vendordMsg);

            const vendorlnMSg = "Please enter the name of your MedStar Health leader";
            schema.leaderName = yup.string(vendorlnMSg)
                .required(vendorlnMSg)
                .min(5, vendorlnMSg);

            const vendorleMsg = "Please enter the email of your MedStar Health leader";
            schema.leaderEmail = yup.string(vendorleMsg)
                .email(vendorleMsg)
                .required(vendorleMsg)
                .min(15, vendorleMsg);
            break;

        // ---------------------
        case MEDSTAR_ASSOCIATION_TYPE__STUDENT:
            const schoolMsg = "Please enter the name of your school";
            const schoolMsgMax = "School name must be less than 30 characters";
            schema.school = yup.string(schoolMsg)
                .required(schoolMsg)
                .min(4, schoolMsg)
                .max(30, schoolMsgMax); // enforce 30 chars max length
                

            const studentmeMsg = "Please select the entity where you apprentice";
            schema.medstarEntity = yup.number(studentmeMsg)
                .required(studentmeMsg)
                .positive(studentmeMsg);

            const studentdMsg = "Please enter the name of the department where you will apprentice";
            schema.department = yup.string(studentdMsg)
                .required(studentdMsg)
                .min(2, studentdMsg);

            const studentlnMSg = "Please enter the name of your MedStar Health leader";
            schema.leaderName = yup.string(studentlnMSg)
                .required(studentlnMSg)
                .min(5, studentlnMSg);

            const studentleMsg = "Please enter the email of your MedStar Health leader";
            schema.leaderEmail = yup.string(studentleMsg)
                .email(studentleMsg)
                .required(studentleMsg)
                .min(15, studentleMsg);
            break;


        // ---------------------
        // TOBEDELETED20230926
        // case MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR:
        //     break;


        // ---------------------
        case MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER:

            const bmMSg = "Please enter the name of your MedStar Health leader";
            schema.leaderName = yup.string(bmMSg);

            const bmMsg = "Please enter the email of your MedStar Health leader";
            schema.leaderEmail = yup.string(bmMsg)
                .email(bmMsg);
            break;


        // ---------------------
        case MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER:
            const meMsg = "Please select the entity where you will volunteer";
            schema.medstarEntity = yup.number(meMsg)
                .required(meMsg)
                .positive(meMsg);

            const dMsg = "Please enter the name of the department where you will volunteer";
            schema.department = yup.string(dMsg)
                .required(dMsg)
                .min(2, dMsg);

            const lnMSg = "Please enter the name of your MedStar Health leader";
            schema.leaderName = yup.string(lnMSg)
                .required(lnMSg)
                .min(5, lnMSg);

            const leMsg = "Please enter the email of your MedStar Health leader";
            schema.leaderEmail = yup.string(leMsg)
                .email(leMsg)
                .required(leMsg);
            break;

        case MEDSTAR_ASSOCIATION_TYPE__UNKNOWN:
            break;

        default:
            throw Error('No medstar association in form schema');
    }

    return yup.object(schema);
}
